const tabs = document.querySelectorAll(".mobile-tab");
const links = document.querySelectorAll(".header-sidebar__linklist");

for (const tab of tabs) {
  tab.addEventListener("click", function handleClick() {
    tabs.forEach((element) => {
      element.classList.remove("active");
    });
    links.forEach((element) => {
      element.classList.remove("active");
    });

    var title = tab.getAttribute("data-title");
    console.log(title);
    tab.classList.add("active");
    document
      .querySelector('[data-menu-title="' + title + '"]')
      .classList.add("active");
  });
}

function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}

if (isTouchDevice()) {
  $(document).on("touchstart", ".product-card__figure", function () {
    $(".product-card__figure").not(this).removeClass("active");
    $(this).addClass("active");
  });
} else {
  $(document).on("click", ".product-card__figure", function () {
    $(".product-card__figure").not(this).removeClass("active");
    $(this).addClass("active");
  });
}
